import { useCallback, useEffect, useState } from 'react'
import { Outlet, useMatch } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import SkipLink from './SkipLink'
import { CourseShellContext } from '../context/CourseShellContext'

export default function Layout() {
  const isCourseRoute = Boolean(useMatch('/course/:slug'))
  const [playerActive, setPlayerActiveState] = useState(false)
  const locked = isCourseRoute && playerActive

  const setPlayerActive = useCallback((active: boolean) => {
    setPlayerActiveState(active)
  }, [])

  useEffect(() => {
    if (!isCourseRoute) setPlayerActiveState(false)
  }, [isCourseRoute])

  // Hard-stop document scrolling while the lesson player owns the viewport.
  useEffect(() => {
    if (!locked) return
    const { documentElement, body } = document
    const prevHtml = documentElement.style.overflow
    const prevBody = body.style.overflow
    documentElement.style.overflow = 'hidden'
    body.style.overflow = 'hidden'
    return () => {
      documentElement.style.overflow = prevHtml
      body.style.overflow = prevBody
    }
  }, [locked])

  return (
    <CourseShellContext.Provider value={{ setPlayerActive }}>
      <div
        className={
          locked
            ? 'flex flex-col h-dvh overflow-hidden'
            : 'flex flex-col min-h-screen'
        }
      >
        <SkipLink />
        <Header />
        <main
          id="main-content"
          className={locked ? 'flex-1 min-h-0 overflow-hidden' : 'flex-1'}
          tabIndex={-1}
        >
          <Outlet />
        </main>
        {!locked && <Footer />}
      </div>
    </CourseShellContext.Provider>
  )
}
